/**
 * "Data market" label (authorization plan Phase 5 and decision D8; D-frontend D19).
 *
 * On pages whose data is contract data the header country filter is an authorization
 * dimension: the server limits contracts to the countries of the active role's scope, and the
 * filter only narrows inside them (country filter audit, 2026-10-12). There the filter reads
 * "Data market". Everywhere else the country only filters and keeps the label "Country":
 * partner profile data has no market scope (D8), activations are not limited by the user's
 * countries (B17), and neither is market data (D8c).
 */

/** Page (first path segment, or `listview/<name>`) => the tabs with contract data, or every tab. */
const DATA_MARKET_PAGES: Record<string, 'all' | readonly string[]> = {
  /** Home dashboard: contract investment graphs. */
  dashboard: 'all',
  /** Contract list page (follows the header country, N3). */
  'listview/contract': 'all',
  /** Brand profile: Portfolio (contract investments) and Contracts. */
  brandprofile: ['portfolio', 'Contracts'],
  /** Partner profile: the Sponsors tab (the partner's contracts); the other tabs are partner data. */
  partnerProfile: ['Contracts'],
};

/** True when the header country filter limits this page's data by the role's countries. */
export function isDataMarketPage(pathname: string, tabName: string | null | undefined): boolean {
  const [page = '', sub = ''] = pathname.split('/').filter(Boolean);
  const tabs = DATA_MARKET_PAGES[`${page}/${sub}`] ?? DATA_MARKET_PAGES[page];
  if (tabs === undefined) return false;
  if (tabs === 'all') return true;
  return Boolean(tabName) && tabs.includes(tabName as string);
}

/** i18n keys (namespace `common`) of the label and its tooltip. */
export const DATA_MARKET_LABEL_KEY = 'dataMarket';
export const DATA_MARKET_TOOLTIP_KEY = 'dataMarketTooltip';
